/**
 * AuthorCard Component
 *
 * Displays "Builder Buddy Team" as the author
 */

import { Users } from "lucide-react";

interface AuthorCardProps {
  variant?: "compact" | "full";
}

export function AuthorCard({ variant = "compact" }: AuthorCardProps) {
  if (variant === "compact") {
    return (
      <div className="flex items-center gap-2">
        <Users className="h-4 w-4 text-teal-600" />
        <p className="font-medium text-gray-700">Builder Buddy Team</p>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 p-4 bg-teal-50 rounded-lg">
      <div className="w-12 h-12 rounded-full bg-gradient-to-br from-teal-500 to-cyan-500 flex items-center justify-center flex-shrink-0">
        <Users className="h-6 w-6 text-white" />
      </div>
      <div>
        <h4 className="font-semibold text-gray-900">Builder Buddy Team</h4>
        <p className="text-teal-600 text-sm">
          Your Calgary Building Code Experts
        </p>
      </div>
    </div>
  );
}

export default AuthorCard;
